// Noms d'événements Socket.IO du namespace /claim, alignés sur
// cliclaim-backend/src/claim/claim.gateway.ts. Ne pas inventer d'événement
// ici : tout nom absent du gateway ne sera jamais reçu.

// Serveur → client
export const NOTIF_MESSAGE = 'notif-message'; // { claimId, message, type: 'new_message' }
export const NOTIF_FEEDBACK = 'notif-feedback'; // { result, claimId }
export const MESSAGES_SEEN = 'messages:seen'; // { claimId, viewedBy, viewedAt }

// Client → serveur
export const CLAIM_JOIN = 'claim:join'; // claimId
export const CLAIM_LEAVE = 'claim:leave'; // claimId
export const MARK_MESSAGES_SEEN = 'messages:seen'; // { claimId }
